import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { AwardSavingDto, EventValueDto } from "../../../autogen/bff-api";
import { formatMoney } from "../../../common/formatting/displaySum";

const money = (value: EventValueDto, amount = value.value ?? 0) =>
  `${formatMoney(amount)} ${value.currency}`;

export const AwardSavingLine = ({ saving }: { saving: AwardSavingDto | undefined }) => {
  const { t, i18n } = useTranslation();
  if (!saving) return null;
  const amount = saving.saving.value ?? 0;
  const percent =
    saving.savingPercent != null
      ? ` (${Math.abs(saving.savingPercent).toLocaleString(i18n.language === "no" ? "nb-NO" : "en-GB", {
          maximumFractionDigits: 2,
        })} %)`
      : "";
  const values = {
    amount: money(saving.saving, Math.abs(amount)),
    percent,
    original: money(saving.originalPrice),
    final: money(saving.finalPrice),
  };
  const text =
    amount > 0
      ? t("Saved through negotiation: {{amount}}{{percent}}, from {{original}} to {{final}}", values)
      : amount < 0
        ? t("The price rose through negotiation: {{amount}}{{percent}}, from {{original}} to {{final}}", values)
        : t("The price did not change through negotiation: {{original}}", values);
  return (
    <Text fontSize="sm" color="smMuted" pl="7">
      {text}
    </Text>
  );
};
